<div class="login-page">
	<mat-card class="login-card">

		<ng-template [ngIf]="view=='sign-in'">
			<mat-card-title>Sign In</mat-card-title>
			<mat-card-content>
				<div class="third-parties" style="display: none;">
					<button type="button" #googleSignin>
						<img src="/assets/google/1x/btn_google_signin_dark_normal_web.png"/>
					</button>
				</div>
				<form (submit)="login_submit(email, password)">
					<mat-form-field class="full-width">
						<mat-icon matPrefix>email</mat-icon>
						<input type="text" name="email" [(ngModel)]="email" matInput required>
						<mat-placeholder>Email</mat-placeholder>
					</mat-form-field>
					<mat-form-field class="full-width">
						<mat-icon matPrefix>lock</mat-icon>
						<input type="password" name="password" [(ngModel)]="password" matInput required>
						<mat-placeholder>Password</mat-placeholder>
						<mat-error *ngIf="errors.password">{{errors.password}}</mat-error>
					</mat-form-field>
					<div class="form-actions">
						<button mat-raised-button color="primary" type="submit">Sign In</button>
					</div>
					<div class="switch-mode">
						<span>Don't have an account?</span>
						<button type="button" mat-button (click)="view='sign-up'">Sign Up</button>
					</div>
				</form>
			</mat-card-content>
		</ng-template>

		<ng-template [ngIf]="view=='sign-up'">
			<mat-card-title>Create Account</mat-card-title>
			<mat-card-content>
				<form (submit)="login_submit(email, password, confirm)">
					<mat-form-field class="full-width">
						<mat-icon matPrefix>email</mat-icon>
						<input type="text" name="email" [(ngModel)]="email" matInput required>
						<mat-placeholder>Email</mat-placeholder>
					</mat-form-field>
					<mat-form-field class="full-width">
						<mat-icon matPrefix>lock</mat-icon>
						<input type="password" name="password" [(ngModel)]="password" matInput required>
						<mat-placeholder>Password</mat-placeholder>
					</mat-form-field>
					<mat-form-field class="full-width">
						<mat-icon matPrefix>lock</mat-icon>
						<input type="password" name="confirm" [(ngModel)]="confirm" matInput required>
						<mat-placeholder>Confirm Password</mat-placeholder>
					</mat-form-field>
					<div class="form-actions">
						<button mat-raised-button color="primary" type="submit">Sign Up</button>
					</div>
					<div class="switch-mode">
						<span>Already have an account?</span>
						<button type="button" mat-button (click)="view='sign-in'">Sign In</button>
					</div>
				</form>
			</mat-card-content>
		</ng-template>

		<ng-template [ngIf]="view=='spinner'">
			<mat-card-content class="spinner-container">
				<mat-spinner></mat-spinner>
			</mat-card-content>
		</ng-template>

	</mat-card>
</div>
